export default __webpack_public_path__ + "static/media/delete_warning_image.fc22f9fe.svg";